// src/auth/authReducer.js
// Define the initial state of the authentication part of the application
const initialState = {
    token: null, // To store the authentication token
    isAuthenticated: false, // Flag to indicate if the user is authenticated
    error: null, // To store any authentication error messages
};

// Define the authentication reducer function
export const authReducer = (state = initialState, action) => {
    // Handle actions with a switch statement based on the action type
    switch (action.type) {
        case 'RESET_AUTH_ERROR':
            return {
                ...state,
                error: null, // Reset the error state
            };
        case 'AUTHENTICATE_USER':
            return {
                ...state,
                isAuthenticated: true,
                // you might also set the user token or details here if needed
            };
        case 'LOGIN_SUCCESS': {
            const { token, userInfo } = action.payload;
            // On login success, set isAuthenticated to true and store the token
            return {
                ...state, // Copy the existing state
                isAuthenticated: true, // Update the isAuthenticated flag
                token, // Store the token from the action payload
                userData: userInfo,
            };
        }
        case 'LOGIN_FAIL':
            // On login failure, store the error message
            return {
                ...state, // Copy the existing state
                error: action.payload, // Store the error message from the action payload
            };
        case 'LOGOUT_SUCCESS':
            return {
                ...initialState, // Reset to initial state
                error: state.error, // Maintain the error state upon logout success to clear it explicitly
            };
        case 'ADD_WATCHLIST_SUCCESS':
            return {
                ...state,
                watchlists: [...state.watchlists, action.payload], // Add the new watchlist to the existing list
            };
        default:
            // If the action type is not recognized, return the current state unchanged
            return state;
    }
};
